<template>
    <div id="fs" @click="fs">
        <img :src="srcFs" alt="Plein-écran">
        <!--<img :src="srcP" @click="pp" alt="Lecture ou Pause"/>-->
    </div>
</template>
<script>
    import screenfull from 'screenfull'
    import exitFs from '@/assets/svg/full-screen-exit.svg'
    import goFs from '@/assets/svg/switch-to-full-screen-button.svg'
    import play from '@/assets/svg/play-button.svg'
    import pause from '@/assets/svg/pause-button.svg'

    export default {
        name: 'FullScreenButton',
        data() {
            return {
                srcFs: exitFs
            }
        },
        methods: {
            fs() {
                if (this.srcFs === exitFs) {
                    this.srcFs = goFs
                } else {
                    this.srcFs = exitFs
                }
                if (screenfull.enabled) {
                    screenfull.toggle();
                }
            },
            pp() {
                let verifVideo = document.querySelector("video")
                if (verifVideo.paused === true) {
                    this.$parent.video.play()
                    this.srcP = pause
                } else {
                    this.$parent.video.pause()
                    this.srcP = play
                }

            }
        }
    }
</script>
<style scoped lang="scss">
    #fs {
        animation-delay: 5s;
        position: fixed;
        right:  5px;
        bottom: 5px;
        z-index: 10;
        background-color: #000;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 10px;
        opacity: 0.51;
        cursor: pointer;
        transition: 200ms;
        z-index: 12;
        img {
            cursor: pointer;
            transition: 300ms;
            width: 20px;
            &:hover {
                transform: scale(1.1, 1.1);
            }
        }
        &:hover {
            opacity: 1;
        }
    }
</style>